export enum CollapseEvent {
  COLLAPSE = 'CollapseEvent:COLLAPSE',
  EXPAND = 'CollapseEvent:EXPAND'
}
